import CancelIcon0 from '@mui/icons-material/Cancel';
import { useId } from 'react';

export default function CancelIcon() {
    const gradientId = useId(); // Creates unique ID for each component instance
    
    return (
        <>
            <svg width={0} height={0}>
                <linearGradient id={gradientId} x1={0} y1={1} x2={1} y2={0} gradientTransform="rotate(0)">
                    <stop offset='0%' stopColor="#f5fbfc" />
                    <stop offset='100%' stopColor="#ffffff" />
                </linearGradient>
            </svg>
            <CancelIcon0 sx={{ fill: `url(#${gradientId})`, fontSize: "26px", display: "inline-block" }} />
        </>
    )
};